import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=2d3c3680&scoped=true"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"
import style0 from "./checkout.vue?vue&type=style&index=0&id=2d3c3680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c3680",
  null
  
)

export default component.exports